export const SYSTEM_SETTING = "SYSTEM_SETTING";